import { type DecoratedProduct } from '~/utils/shop/DecoratedProduct';

export default function isSoftwareProduct(
  decoratedProduct?: DecoratedProduct | null
) {
  return (
    decoratedProduct?.product?.attribute_set_name === 'Pim Software (software)'
  );
}
